import { render, staticRenderFns } from "./UsersReport.vue?vue&type=template&id=1cadc4c2&"
import script from "./UsersReport.vue?vue&type=script&lang=js&"
export * from "./UsersReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lee/Developer/Auris/admin-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cadc4c2')) {
      api.createRecord('1cadc4c2', component.options)
    } else {
      api.reload('1cadc4c2', component.options)
    }
    module.hot.accept("./UsersReport.vue?vue&type=template&id=1cadc4c2&", function () {
      api.rerender('1cadc4c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/UsersReport.vue"
export default component.exports